<div class="platform-header-container">
  <div class="content">
    <div class="item title">
      <ng-content select="[title]"></ng-content>
    </div>
    <div class="item links">
      <div class="version"><ng-content select="[version]"></ng-content></div>
      <div class="link">
        <ng-content select="[links]"></ng-content>
      </div>
    </div>
  </div>
</div>
